import styled from 'styled-components';

export const ItemText= styled.div`
  width: 3.0rem;
  color: ${({ theme }) => theme.color.textPrime};
  font-size: 0.875rem;
  text-align: center;
`;